export default "__VITE_ASSET__Dpf6ILj___"